import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { WINDOW } from '@app/shared/tokens';
import { BaseRoute } from '@core/data-access/models/routes.model';
import { ScriptInjectionManager } from '@core/data-access/services/scripts/script-injection-manager';
import { RouterActions } from '@core/data-access/store/router/router.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { routerNavigatedAction } from '@ngrx/router-store';
import { ReloadScripts, ResetScripts } from '@store/exhibition/exhibition.actions';
import { includes } from 'lodash';
import { filter, map, tap } from 'rxjs';

export const navigate$ = createEffect(
  (actions$ = inject(Actions), router = inject(Router)) =>
    actions$.pipe(
      ofType(RouterActions.go),
      tap(({ path, queryParams, extras }) => {
        router.navigate(path, { queryParams, ...extras });
      })
    ),
  { functional: true, dispatch: false }
);

export const checkResetScriptsOnNavigateToEventSelection$ = createEffect(
  (actions$ = inject(Actions), router = inject(Router), scriptInjectionManager = inject(ScriptInjectionManager)) =>
    actions$.pipe(
      ofType(RouterActions.navigateToEventSelection),
      tap(() => router.navigate(['/'])),
      scriptInjectionManager.reloadScriptsOnEventSelectionCheck$(),
      filter((reloadScripts) => reloadScripts),
      map(() => new ResetScripts())
    ),
  { functional: true }
);

export const checkReloadScriptsOnNavigateToSelectedEvent$ = createEffect(
  (actions$ = inject(Actions), window = inject(WINDOW), scriptInjectionManager = inject(ScriptInjectionManager)) =>
    actions$.pipe(
      ofType(RouterActions.navigateToSelectedEvent),
      scriptInjectionManager.reloadScriptsOnSelectEventCheck$(),
      map(({ eventId, reloadScripts }) => {
        const subRoute = `${BaseRoute.WebShop}/${eventId}`;

        if (reloadScripts) {
          const url = window.location.href + subRoute;

          return new ReloadScripts(url);
        }

        return RouterActions.go({ path: [subRoute] });
      })
    ),
  { functional: true }
);

export const navigatedToProfileRoute$ = createEffect(
  (actions$ = inject(Actions)) =>
    actions$.pipe(
      ofType(routerNavigatedAction),
      filter(({ payload }) => includes(payload.routerState.url, BaseRoute.Profile)),
      map(() => RouterActions.navigatedToProfileRoute())
    ),
  { functional: true }
);
